<template>
  <div class="article-detail">
    <div class="title t-l f19" style="font-weight: bold">
      {{ detail.title ? detail.title : "" }}
    </div>
    <div class="creater">{{ detail.creater ? detail.creater : "" }}</div>
    <div class="topInfo">
      <div class="create-time t-l f11 time">
        {{ detail.created_at ? detail.created_at : "" }}
      </div>
      <div class="moreInfo" @click="goMoreTips"><span>更多文章</span></div>
    </div>

    <div class="pic">
      <img :src="detail.thumb_url" alt />
    </div>
    <div class="content t-l" v-html="detail.content"></div>
    <template v-if="showHomeTab"><HomeTab /></template>
  </div>
</template>

<script>
import HomeTab from "@/components/HomeTab.vue";
import { getData } from "../Interface/http.js";
export default {
  name: "articleDetail",
  data() {
    return {
      detail: {},
      showHomeTab: true,
    };
  },
  computed: {
    details() {
      if (JSON.stringify(this.$store.state.articleDetail) !== "{}") {
        return this.$store.state.articleDetail;
      } else {
        return JSON.parse(sessionStorage.getItem("articleDetail"));
      }
    },
    title() {
      if (this.$store.state.articleDetail) {
        return this.$store.state.articleDetail.title;
      } else {
        let a = sessionStorage.getItem("articleDetail");
        return a.title;
      }
    },
    creater() {
      return "";
    },
    time() {
      if (this.$store.state.articleDetail) {
        return this.$store.state.articleDetail.created_at;
      } else {
        let a = sessionStorage.getItem("articleDetail");
        return a.created_at;
      }
    },
    pics() {
      if (this.$store.state.articleDetail) {
        return this.$store.state.articleDetail.thumb_url;
      } else {
        let a = sessionStorage.getItem("articleDetail");
        return a.thumb_url;
      }
    },
    content() {
      if (this.$store.state.articleDetail) {
        return this.$store.state.articleDetail.content;
      } else {
        let a = sessionStorage.getItem("articleDetail");
        return a.content;
      }
    },
  },
  mounted() {
    //this.$store.commit("UPDATEATBINDEX", { tag: (this.$route.query.active -0) });
    if (this.$route.query.hiddenTab) {
      this.showHomeTab = false;
    }
    this.getDetail();
  },
  methods: {
    goMoreTips() {
      //跳转更多文章页面
      this.$router.push({
        path: "read",
        query: { active: 3 },
      });
    },
    getDetail() {
      getData("/article/show", {
        id: this.$route.query.id,
      }).then((res) => {
        this.detail = res.data;
      });
    },
  },
  components: {
    HomeTab,
  },
};
</script>

<style scoped>
.article-detail {
  padding: 30px 15px 0;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: #fff;
}
.time {
  margin: 20px 0;
}
.topInfo {
  display: flex;
}
.moreInfo {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-grow: 1;
  font-weight: bold;
  color: #29a1d8;
}
</style>
